import React, {useState}  from 'react'

function EditServiceForm({service, handleUpdateService}) {
    const [nomInstitution, setNomInstitution] = useState(service.nomInstitution);
      const [telephone, setTelephone] = useState(service.telephone);
      const [typeInstitution, setTypeInstitution] = useState(service.typeIntitution);
      const [structure, setStructure] = useState(service.structure);
      const [adresseInstitution, setAdresseInstitution] = useState(service.adresse);
      const [email, setEmail] = useState(service.email);
      const [job, setJob] = useState(service.job);

      const handleSubmit = (e) => {
        e.preventDefault();
        const updatedService = {
            nomInstitution,
            adresseInstitution,
          telephone,
          typeInstitution,
          structure,
          job,
        };
        handleUpdateService(updatedService);
      };
  return (
    <div className="inscription-container">
        <form onSubmit={handleSubmit} className='inscription-form'>
        
            <div className="form-step">
            <h2 className='inscription-title'>Informations de l'institution</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom de l’institution</label>
                    <input type="text" name="nomInstitution" value={nomInstitution} onChange={(e) => setNomInstitution(e.target.value)} placeholder="Entrez le Nom de l’institution" />
                    
                </div>
                <div className="form-group">
                    <label>Adresse de l’institution</label>
                    <input type="text" name="adresseInstitution" value={adresseInstitution} onChange={(e) => setAdresseInstitution(e.target.value)} placeholder="Entrez l'adresse de l’institution'" />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Entrez l'email"  required disabled/>
                </div>
                <div className="form-group">
                    <label>Numéro de téléphone de l'institut</label>
                    <input type="tel" name="telephone" value={telephone} onChange={(e) => setTelephone(e.target.value)} placeholder="+223 ..." />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Type d’institution</label>
                    <select name="typeInstitution" value={typeInstitution} onChange={(e) => setTypeInstitution(e.target.value)}>
                        <option value="Hôpital">Hôpital</option>
                        <option value="Clinique">Clinique</option>
                        <option value="Entreprise">Entreprise</option>
                    </select>
                </div>
            </div>
            </div>
        

            <button type="submit" className="submit-button">
            Enregistrer
            </button>
        </form>
    </div>
  )
}

export default EditServiceForm